import Vue from "vue";
import constants from "../../../constants";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import dePartmentService from "../../../services/departmentService";
import h from "../../../services/h";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import hcCfgMeetingRoomService from "../../../services/hcCfgMeetingRoomService";
import hcMobimeetingRoomService from "../../../services/hcMobimeetingRoomService";
import meetingRoomService from "../../../services/meetingRoomService";

export default {
  props: ["isOpen", "id"],
  data() {
    return {
      departments: null,
      isBlock: false,
      form: {
        id: null,
        roomName: null,
        roomSize: 0,
        roomDesc: null,
        deptId: null,
        type: null,
        roomCode: null,
        url: null
      },
      rules: {},

      typeOptions: [],
      TYPE: constants.HC_CFG_MEETING_ROOM.TYPE,
      hcCfgMeetingRoom: null,
      hcMobimeetingRoom: null,
    };
  },

  computed: {
    dialogTitle() {
      return !this.id ? "Thêm mới phòng họp" : "Cập nhật phòng họp";
    }
  },

  methods: {
    prepareForEdit() {
      return this.loadHcCfgMeetingRoom()
        .then(() => this.loadHcMobimeetingRoom())
        .then(() => this.bindDataToForm());
    },

    loadHcMobimeetingRoom() {
      return this.hcCfgMeetingRoom.hcMeetingRoomId
        ? hcMobimeetingRoomService
            .findById(this.hcCfgMeetingRoom.hcMeetingRoomId)
            .then(response => (this.hcMobimeetingRoom = response.data))
        : null;
    },

    loadHcCfgMeetingRoom() {
      return hcCfgMeetingRoomService
        .findById(this.id)
        .then(response => (this.hcCfgMeetingRoom = response.data));
    },

    roomCodeChanged() {
      this.form.url = this.form.roomCode
        ? `https://meeting.mobifone.vn/${this.form.roomCode}`
        : null;
    },

    typeChanged() {
      this.form.roomSize = null;
      this.form.roomCode = null;
      this.form.url = null;
      this.$refs.form.clearValidate();
      this.$refs.form.validateField("type");
      this.initValidationRules();
    },

    checkRoomCode() {
      if (this.form.url) {
        window.open(this.form.url, "_blank");
      }
    },

    checkRoomUrl() {
      if (this.form.url) {
        window.open(this.form.url, "_blank");
      }
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };

      Vue.set(this.rules, "roomName", [defaultRequiredConstrains]);
      Vue.set(this.rules, "deptId", [defaultRequiredConstrains]);
      Vue.set(this.rules, "type", [defaultRequiredConstrains]);

      if (
        this.form.type ===
        constants.HC_CFG_MEETING_ROOM.TYPE.ONLINE_MOBIMEETING_CODINH
      ) {
        Vue.set(this.rules, "roomCode", [defaultRequiredConstrains]);
        Vue.set(this.rules, "url", [defaultRequiredConstrains]);
        Vue.set(this.rules, "roomSize", null);
      } else if (this.form.type === constants.HC_CFG_MEETING_ROOM.TYPE.NORMAL) {
        Vue.set(this.rules, "roomCode", null);
        Vue.set(this.rules, "url", null);
        Vue.set(this.rules, "roomSize", [defaultRequiredConstrains]);
      } else {
        Vue.set(this.rules, "roomCode", null);
        Vue.set(this.rules, "url", null);
        Vue.set(this.rules, "roomSize", null);
      }
    },

    initOptions() {
      this.typeOptions = h.collect(
        [constants.HC_CFG_MEETING_ROOM.TYPE.NORMAL],
        type => {
          return { value: type, label: hanhChinhUtils.getRoomTypeLabel(type) };
        }
      );
    },

    loadDepartments() {
      return dePartmentService
        .findAll({
          page: 0,
          size: 1000,
          sort: "path,asc",
        })
        .then((response) => {
          this.departments = h.findAll(
            response.data,
            (item) =>
              this.isEdit || item.status === constants.DEPARTMENT.STATUS.ACTIVE
          );
        });
    },

    cancel() {
      this.$emit("closeDialog");
    },

    bindDataToForm() {
      this.form.roomName = this.hcCfgMeetingRoom.roomName;
      this.form.roomSize = this.hcCfgMeetingRoom.roomSize;
      this.form.roomDesc = this.hcCfgMeetingRoom.roomDesc;
      this.form.deptId = this.hcCfgMeetingRoom.deptId;
      this.form.type = this.hcCfgMeetingRoom.type;
      this.form.roomCode = this.hcMobimeetingRoom.roomCode;
      this.form.url = this.hcMobimeetingRoom.url;
    },

    convertToSubmitForm() {
      return {
        roomName: this.form.roomName,
        deptId: this.form.deptId,
        roomSize: this.form.roomSize,
        roomDesc: this.form.roomDesc,
        type: this.form.type,
        roomCode: this.form.roomCode,
        url: this.form.url
      };
    },

    delete_() {
      return this.$confirm(
        errorMessageFilter({
          errorCode: "meetingRoom.delete.confirm"
        }),
        {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy",
          type: "warning"
        }
      )
        .then(() => meetingRoomService.delete(this.id))
        .then(response => {
          this.$message({
            message: "Xóa phòng họp thành công",
            type: "success"
          });
          this.$emit("deleteSuccess", { result: response.data });
        });
    },

    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (!valid) return;
          resolve();
        });
      });
    },

    save() {
      this.validateForm()
        .then(() => (this.id ? this.update_() : this.save_()))
        .then(hcCfgMeetingRoom => {
          this.$message({
            message: this.id
              ? "Cập nhật phòng họp thành công"
              : "Tạo mới phòng họp thành công",
            type: "success"
          });
          this.id
            ? this.$emit("updateSuccess", { result: hcCfgMeetingRoom })
            : this.$emit("insertSuccess", { result: hcCfgMeetingRoom });
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    },

    update_() {
      return meetingRoomService
        .update(this.id, this.convertToSubmitForm())
        .then(response => response.data);
    },

    save_() {
      return meetingRoomService
        .create(this.convertToSubmitForm())
        .then(response => response.data);
    },

    isAdmin() {
      return (
        this.$store.getters.userDeptRole &&
        this.$store.getters.userDeptRole.roleCode === constants.ROLE.CODE.ADMIN
      );
    },
  }
};



// WEBPACK FOOTER //
// ./src/views/setting/quanLyPhongHop/hcCfgMeetingRoomCreateDialogMixin.js